/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_carpets_delete_confirm_description = /** @type {(inputs: {}) => string} */ () => {
	return `Las tarjetas en esta carpeta se moverán a sin agrupar. Esta acción no se puede deshacer.`
};

const en_cards_carpets_delete_confirm_description = /** @type {(inputs: {}) => string} */ () => {
	return `Cards in this carpet will be moved to ungrouped. This action cannot be undone.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_carpets_delete_confirm_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_carpets_delete_confirm_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_carpets_delete_confirm_description", locale)
	if (locale === "es") return es_cards_carpets_delete_confirm_description(inputs)
	return en_cards_carpets_delete_confirm_description(inputs)
};
export { cards_carpets_delete_confirm_description as "cards.carpets.delete_confirm_description" }